// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerLineMenu__link__count":"fh_a bhc_fg","SellerLineMenu__link--active":"fh_b bhc_ea"};